module.exports = __webpack_public_path__ + "static/media/bg_top_login_m.33dc4d43.png";